import { Col, Row, Tag, Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useFormContext } from '../../components/forms/forms';
import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import { DateFormatLongNoWeekday } from '../../utils/dateFormatting';
import { useReportsSharedStyles } from './reportsShared.styles';
import { useReportsDownloadSummaryStyles } from './ReportsDownloadSummary.styles';

export function ReportsDownloadSummary() {
  const { values } = useFormContext();
  const { styles: sharedStyles } = useReportsSharedStyles();
  const { styles } = useReportsDownloadSummaryStyles();

  return (
    <div className={sharedStyles.reportsSectionContent}>
      <div
        className={classNames(
          sharedStyles.reportsSectionTitle,
          'no-margin-form-items'
        )}
      >
        <Typography.Title level={3}>
          4. <FormattedMessage id="reports.downloadSummary.title" />
        </Typography.Title>
      </div>
      <div
        className={classNames(
          sharedStyles.selectionSection,
          styles.selectionSectionSummary,
          'spaces-vert-norm3'
        )}
      >
        <div>
          <div className={sharedStyles.selectionSectionTitle}>
            <FormattedMessage id="reports.reportSelection" />
          </div>
          <div className={styles.selectionSectionFooter}>
            {values.selectedReports.map(report => (
              <Tag
                className={sharedStyles.selectionTag}
                key={`report-summary-tag-${report.code}`}
              >
                {report.text}
              </Tag>
            ))}
          </div>
        </div>
        <div>
          <div className={sharedStyles.selectionSectionTitle}>
            <FormattedMessage id="reports.accountSelection" />
          </div>
          <div className={styles.selectionSectionFooter}>
            {values.selectedAccounts.map(acc => (
              <Tag
                className={sharedStyles.selectionTag}
                key={`report-summary-tag-${acc.number}`}
              >
                {acc.number}
              </Tag>
            ))}
          </div>
        </div>
        <div>
          <Row gutter={pxToNumber(cssVariables.spaceNorm3)}>
            <Col span={12}>
              <div className={sharedStyles.selectionSection}>
                <div className={sharedStyles.selectionSectionTitle}>
                  <FormattedMessage id="reports.downloadSummary.startDate" />
                </div>
                <div
                  className={classNames(
                    sharedStyles.selectionSectionBody,
                    styles.summaryDateBody
                  )}
                >
                  <DateFormatLongNoWeekday value={values.dateStart} />
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={sharedStyles.selectionSection}>
                <div className={sharedStyles.selectionSectionTitle}>
                  <FormattedMessage id="reports.downloadSummary.endDate" />
                </div>
                <div
                  className={classNames(
                    sharedStyles.selectionSectionBody,
                    styles.summaryDateBody
                  )}
                >
                  <DateFormatLongNoWeekday value={values.dateEnd} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
